import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  DashboardOverviewQuery,
  DashboardOverviewResult,
  DashboardTargetsQuery,
  DashboardTargetsResult,
  UpdateDashboardTargetsBody,
  WinAnalysisBucketRow,
  WinAnalysisDiscountRow,
  WinAnalysisOverviewResult,
  WinAnalysisProductComboResult,
  WinAnalysisQuery,
  WinAnalysisSalesRankingRow,
  WinAnalysisSilentQuoteRow,
} from './types/dashboard';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/dashboard';

export async function queryDashboardOverview(
  params: DashboardOverviewQuery,
  options?: ApiRequestOptions,
) {
  return request<DashboardOverviewResult>(`${BASE_PATH}/overview`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function queryDashboardTargets(
  params: DashboardTargetsQuery,
  options?: ApiRequestOptions,
) {
  return request<DashboardTargetsResult>(`${BASE_PATH}/targets`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function updateDashboardTargets(
  body: UpdateDashboardTargetsBody,
  options?: ApiRequestOptions,
) {
  return request<DashboardTargetsResult>(`${BASE_PATH}/targets`, {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

export async function queryWinAnalysisOverview(
  params: WinAnalysisQuery,
  options?: ApiRequestOptions,
) {
  return request<WinAnalysisOverviewResult>(`${BASE_PATH}/win-analysis/overview`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function queryWinAnalysisPriceBuckets(
  params: WinAnalysisQuery,
  options?: ApiRequestOptions,
) {
  return request<WinAnalysisBucketRow[]>(`${BASE_PATH}/win-analysis/price-buckets`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function queryWinAnalysisDiscount(
  params: WinAnalysisQuery,
  options?: ApiRequestOptions,
) {
  return request<WinAnalysisDiscountRow[]>(`${BASE_PATH}/win-analysis/discount`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function queryWinAnalysisProductCombos(
  params: WinAnalysisQuery,
  options?: ApiRequestOptions,
) {
  return request<WinAnalysisProductComboResult>(`${BASE_PATH}/win-analysis/product-combos`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function queryWinAnalysisSilentQuotes(
  params: WinAnalysisQuery,
  options?: ApiRequestOptions,
) {
  return request<WinAnalysisSilentQuoteRow[]>(`${BASE_PATH}/win-analysis/silent-quotes`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function queryWinAnalysisSalesRanking(
  params: WinAnalysisQuery,
  options?: ApiRequestOptions,
) {
  return request<WinAnalysisSalesRankingRow[]>(`${BASE_PATH}/win-analysis/sales-ranking`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
